import { Injectable, inject } from "@angular/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { BehaviorSubject, Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LorenBreakpointObserverService {
  private breakpointObserver = inject(BreakpointObserver);

  private isHandset$: Observable<boolean>;
  private isMedium$: Observable<boolean>;
  private isLarge$: Observable<boolean>;
  private isExtraLarge$: Observable<boolean>;
  private isCustomXXL$: Observable<boolean>;
  private isTablet$: Observable<boolean>;

  private contentWrapperHeightSubject = new BehaviorSubject(null);
  contentWrapperHeight$: Observable<number> =
    this.contentWrapperHeightSubject.asObservable();

  public getHandsetStateSubscription(): Observable<boolean> {
    if (!this.isHandset$) {
      this.isHandset$ = this.breakpointObserver
        .observe(Breakpoints.Handset)
        .pipe(
          map((result) => result.matches),
          shareReplay()
        );
    }

    return this.isHandset$;
  }

  public getMediumStateSubscription(): Observable<boolean> {
    if (!this.isMedium$) {
      this.isMedium$ = this.breakpointObserver.observe(Breakpoints.Medium).pipe(
        map((result) => result.matches),
        shareReplay()
      );
    }

    return this.isMedium$;
  }

  public getLargeStateSubscription(): Observable<boolean> {
    if (!this.isLarge$) {
      this.isLarge$ = this.breakpointObserver.observe(Breakpoints.Large).pipe(
        map((result) => result.matches),
        shareReplay()
      );
    }

    return this.isLarge$;
  }

  public getExtraLargeStateSubscription(): Observable<boolean> {
    if (!this.isExtraLarge$) {
      this.isExtraLarge$ = this.breakpointObserver
        .observe(Breakpoints.XLarge)
        .pipe(
          map((result) => result.matches),
          shareReplay()
        );
    }

    return this.isExtraLarge$;
  }

  public getCustomXXLStateSubscription(): Observable<boolean> {
    if (!this.isCustomXXL$) {
      this.isCustomXXL$ = this.breakpointObserver
        .observe("(min-width: 2560px)")
        .pipe(
          map((result) => result.matches),
          shareReplay()
        );
    }

    return this.isCustomXXL$;
  }

  public getTabletStateSubscription(): Observable<boolean> {
    if (!this.isTablet$) {
      this.isTablet$ = this.breakpointObserver.observe(Breakpoints.Tablet).pipe(
        map((result) => result.matches),
        shareReplay()
      );
    }

    return this.isTablet$;
  }

  public setContentWrapperHeight(height: number) {
    this.contentWrapperHeightSubject.next(height);
  }
}
